import { useMemo } from 'react';
import { Dropdown } from 'antd';
import TalentCandidate from "../../../models/TalentCandidate";

const CandidateSort = ({ sortBy, onChange = () => true, options = TalentCandidate.matchSortingOptions(), ...props }) => {
    const activeSort = useMemo(() => {
        return options[sortBy] || TB.first(Object.values(options))
    }, [sortBy])

    return (
        <Dropdown
            menu={{
                items: TB.map(options, (label, key) => ({
                    label, key
                })),
                selectedKeys: sortBy,
                onClick: e => onChange(e.key)
            }}
            trigger={['click']}
        >
            <a onClick={(e) => e.preventDefault()} className="flex items-center">
                <span className="text-black">Sort:</span>
                <span className="text-primary mr-1">&nbsp;&nbsp;{activeSort}</span>
                <span className="w-0 h-0
                        border-l-[4px] border-l-transparent
                        border-t-[5px] border-t-black group-hover:border-t-black
                        border-r-[4px] border-r-transparent"
                />
            </a>
        </Dropdown>
    );
};

export default CandidateSort;